import React from 'react'
import QuoteIcon from '~/images/quote.svg'
import WebregataIcon from '~/images/webregata.svg'
import RocketSalesIcon from '~/images/rocket.svg'
import LoftylabIcon from '~/images/lofty.svg'
import WebregataDarkIcon from '~/images/webregata-dark.svg'
import RocketSalesDarkIcon from '~/images/rocket-dark.svg'
import LoftylabDarkIcon from '~/images/lofty-dark.svg'
import classNames from 'classnames'
import { getReviews } from '~/helpers/constant'

export const Reviews: React.FC = () => {
  const reviews = getReviews()
  const [review, setReview] = React.useState<number>(0)
  const ref = React.useRef(null)

  const getReview = (index: number) => (
    setReview(index)
  )

  let touchstartX = 0
  let touchendX = 0

  const touchStartHandler = (evt: TouchEvent) => {
    touchstartX = evt.changedTouches[0].screenX
  }
  const touchEndHandler = (evt: TouchEvent) => {
    touchendX = evt.changedTouches[0].screenX
    handleGesture()
  }
  React.useEffect(() => {
    ref.current.addEventListener('touchstart', touchStartHandler)
    ref.current.addEventListener('touchend', touchEndHandler)
    return () => {
      ref.current.removeEventListener('touchstart', touchStartHandler)
      ref.current.removeEventListener('touchend', touchEndHandler)
    }
  })

  const handleGesture = () => {
    if (Math.abs(touchendX - touchstartX) < 100) return
    if (touchendX <= touchstartX) {
      if (review === reviews.length - 1) {
        setReview(0)
      } else {
        setReview(review + 1)
      }
    }

    if (touchendX >= touchstartX) {
      if (review === 0) {
        setReview(reviews.length - 1)
      } else {
        setReview(review - 1)
      }
    }
  }
  return (
    <div className='onlinepbx__partners__reviews__wrapper'>
      <div className='onlinepbx__partners__reviews__container'>
        <div
          ref={ref}
          className='onlinepbx__partners__reviews'>
          <div className='onlinepbx__partners__reviews__left'>
            <div className='onlinepbx__partners__reviews__quote'>
              <QuoteIcon />
            </div>
            <div
              style={{ fontSize: reviews[review].size }}
              className='onlinepbx__partners__reviews__description'>
              {reviews[review].description}
            </div>
          </div>
          <div className='onlinepbx__partners__reviews__right'>
            <div className='onlinepbx__partners__reviews__right__block'>
              <div className='onlinepbx__partners__reviews__photo'>
                <img src={reviews[review].photo} />
              </div>
              <div className='onlinepbx__partners__reviews__info'>
                <div className='onlinepbx__partners__reviews__name'>
                  {reviews[review].name}
                </div>
                <div className='onlinepbx__partners__reviews__position'>
                  {reviews[review].position}
                </div>
              </div>
            </div>
            <div className='onlinepbx__partners__reviews__logos'>
              <div>
                {
                  review === 0 && <WebregataIcon className='onlinepbx__partners__reviews__logo' /> ||
                  review === 1 && <RocketSalesIcon className='onlinepbx__partners__reviews__logo' /> ||
                  review === 2 && <LoftylabIcon className='onlinepbx__partners__reviews__logo' />
                }
              </div>
            </div>
          </div>
        </div>
        <div className='onlinepbx__partners__reviews__buttons'>
          <button
            className={classNames('onlinepbx__partners__reviews__button', {
              'onlinepbx__partners__reviews__button__active': review === 0
            })}
            onClick={() => getReview(0)}>
            {review === 0 && <WebregataIcon /> || <WebregataDarkIcon />}
          </button>
          <button
            className={classNames('onlinepbx__partners__reviews__button', {
              'onlinepbx__partners__reviews__button__active': review === 1
            })}
            onClick={() => getReview(1)}>
            {review === 1 && <RocketSalesIcon /> || <RocketSalesDarkIcon />}
          </button>
          <button
            className={classNames('onlinepbx__partners__reviews__button', {
              'onlinepbx__partners__reviews__button__active': review === 2
            })}
            onClick={() => getReview(2)}>
            {review === 2 && <LoftylabIcon /> || <LoftylabDarkIcon />}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Reviews

